import { isObjEmpty } from "@/utility/helperFunctions";
import { api } from "./api";
import URI from "./URI";

export const getUserDetails = (populateParams=[]) => {
  
  const queryString = populateParams.length > 0 
    ? populateParams.map(param => `populate=${encodeURIComponent(param)}`).join("&") + "&populate=*"
    : "populate=*";
  
  return api(
    `${URI.userDetails}?${queryString}`,
    { tokenRequired: true },
    import.meta.env.VITE_PSVC_API_BASE
  ).then((response) => {
    const data = response.data.user;
    
    const bankDetails = [
      {
        bankAccountNumber: data.onboarding.bankAccountNumber,
        bankBranch: data.onboarding.bankBranch,
        bankAddress: data.onboarding.bankAddress,
        bankName: data.onboarding.bankName,
        bankIFSCNumber: data.onboarding.bankIFSCNumber,
        isPrimary: true,
      },
      {
        bankAccountNumber: data.onboarding.bankAccountNumberTwo,
        bankBranch: data.onboarding.bankBranchTwo,
        bankAddress: data.onboarding.bankAddressTwo,
        bankName: data.onboarding.bankNameTwo,
        bankIFSCNumber: data.onboarding.bankIFSCNumberTwo,
      },
      {
        bankAccountNumber: data.onboarding.bankAccountNumberThree,
        bankBranch: data.onboarding.bankBranchThree,
        bankAddress: data.onboarding.bankAddressThree,
        bankName: data.onboarding.bankNameThree,
        bankIFSCNumber: data.onboarding.bankIFSCNumberThree,
      },
    ].filter((obj) => !isObjEmpty(obj));

    const nomineeDetails = [
      {
        nomineeName: data.onboarding.nominieeOneName,
        nomineeRelation: data.onboarding.nominieeOneRelation,
        nomineeDob: data.onboarding.nominieeOneDob,
        nomineeAlocation: data.onboarding.nominieeOneAllocation,
      },
      {
        nomineeName: data.onboarding.nominieeTwoName,
        nomineeRelation: data.onboarding.nominieeTwoRelation,
        nomineeDob: data.onboarding.nominieeTwoDob,
        nomineeAlocation: data.onboarding.nominieeTwoAllocation,
      },
      {
        nomineeName: data.onboarding.nominieeThreeName,
        nomineeRelation: data.onboarding.nominieeThreeRelation,
        nomineeDob: data.onboarding.nominieeThreeDob,
        nomineeAlocation: data.onboarding.nominieeThreeAllocation,
      },
    ].filter((obj) => !isObjEmpty(obj));
    
    const transformedData = {
      firstName: data.onboarding.firstName,
      middleName: data.onboarding.middleName,
      lastName: data.onboarding.lastName,
      nameAsITD: data.onboarding.nameAsITD,
      phone: data.phone,
      email: data.email,
      uniqueCientCode: data.uniqueCientCode,
      panNumber: data.onboarding.panNumber,
      selfie : data.onboarding.selfie,
      signature: data.onboarding.signature,
      nameAsAadhar: data.onboarding.nameAsDigilockerAadhaar,
      nameAsPAN: data.onboarding.nameAsDigilockerPan,
      dobAsDigilockerPan: data.onboarding.dobAsDigilockerPan,
      genderAsDigilockerPan: data.onboarding.genderAsDigilockerPan,
      genderAsDigilockerAadhaar: data.onboarding.genderAsDigilockerAadhaar,
      grossAnnualIncome: data.onboarding.grossAnnualIncome,
      maritalStatus: data.onboarding.maritalStatus,
      fatherName : data.onboarding.fatherName,
      emailModifications: data.emailModifications,
      phoneModifications: data.phoneModifications,
      correspondenceAddress: data.onboarding.correspondenceAddress,
      permanentAddress: data.onboarding.permanentAddress,
      currentAddressAsDigilockerAadhaar: data.onboarding.currentAddressAsDigilockerAadhaar,
      permanentAddressAsDigilockerAadhaar: data.onboarding.permanentAddressAsDigilockerAadhaar,
      dp: data.onboarding.dp,
      optedForNSEFO: data.onboarding.pptedForNSEFO,
      optedForBSEFO: data.onboarding.optedForBSEFO,
      optedForEquitySegment: data.onboarding.optedForEquitySegment,
      OptedForDrivativesSegment: data.onboarding.OptedForDrivativesSegment,
      bankDetails,
      ssfbCustomerId: data.ssfb_cid,
      nomineeDetails,
      vkycStatus: data?.vkyc_status,
      // TODO: Validate condition
      isDematUser: data?.onboarding?.clientStatus === "active"
    };

    transformedData.userFullName = transformedData.nameAsPAN || transformedData.nameAsAadhar || transformedData.nameAsITD || "-"
    
    let initialLetters = transformedData.userFullName.split(" ").map(partName => partName?.[0])
    transformedData.initials = `${initialLetters.at(0)}${ initialLetters.length > 1 ? initialLetters.at(-1) : ''}`

    return transformedData;
  }).catch(error => {
    throw error;
  });
};
